import Link from 'next/link';
import { useState } from 'react'; // Import useState to handle coupon code input
import { useAppDispatch, useAppSelector } from '@/lib/redux/hooks';
import { applyCoupon, removeCoupon } from '@/lib/redux/features/token';
import { FaXmark } from 'react-icons/fa6';

const CartCoupon = () => {
  const [couponCode, setCouponCode] = useState(''); // State for capturing coupon input
  const dispatch = useAppDispatch();
  const cart = useAppSelector((state) => state.coupon.code);

  // Handle input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCouponCode(e.target.value);
  };

  // Handle applying the coupon
  const handleApplyCoupon = () => {
    if (couponCode) {
      dispatch(applyCoupon(couponCode)); // Dispatch applyCoupon with dynamic coupon code
    } else {
      alert('Please enter a coupon code'); // Handle case when input is empty
    }
  };

  return (
    <tr>
      <td colSpan={6}>
        <div className="cart__footer">
          {cart ? (
            <div className="cart__coupon">
              <div className="input-group">
                <label htmlFor="cart-coupon" className="form-label mb-0">
                  Coupon Code :
                </label>
                <div>
                  <span style={{ color: 'green' }}>ABC!@#$</span>
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => dispatch(removeCoupon())}
                  >
                    <FaXmark color="red" size={22} />
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="cart__coupon">
              <div className="input-group">
                <label htmlFor="cart-coupon" className="form-label mb-0">
                  Got any tokens?
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="cart-coupon"
                  aria-describedby="cart-coupon"
                  placeholder="Coupon Code"
                  value={couponCode} // Bind the input field value to couponCode state
                  onChange={handleInputChange} // Update state on input change
                />

                <button
                  onClick={handleApplyCoupon} // Apply coupon when clicked
                  className="trk-btn trk-btn--primary"
                  id="basic-addon3"
                >
                  Apply now
                </button>
              </div>
            </div>
          )}
          <br />
          <div className="cart__btn">
            <Link href="#" className="trk-btn trk-btn--primary">
              Update cart
            </Link>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default CartCoupon;
